import type { QueryFunctionContext } from '@tanstack/react-query';

import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(
  `
    query getIndustryTimeseries(
      $ISO2: String!
      $industry: Float!
      $startUnix: Float!
      $endUnix: Float!
      $points: Float
    ) {
      IndustryTimeseries(
        criteria: {
          market: $ISO2
          industry: $industry
          startUnix: $startUnix
          endUnix: $endUnix
          points: $points
        }
      ) {
        industry {
          name
        }
        market {
          iso2
        }
        pe
        ps
        absolutePE
        earnings
        revenue
        marketCap
        averages
        }
    }
  `
);

type Args = VariablesOf<typeof QUERY>;

type QueryContext = QueryFunctionContext<
  [
    string,
    Args['ISO2'],
    Args['industry'],
    Args['startUnix'],
    Args['endUnix'],
    Args['points'],
  ]
>;

export const queryFn = async ({
  queryKey: [_, ISO2, industry, startUnix, endUnix, points],
}: QueryContext) => {
  const response = await gqlClient.request(QUERY, {
    ISO2,
    industry,
    startUnix,
    endUnix,
    points,
  });

  if ('IndustryTimeseries' in response) {
    return response.IndustryTimeseries;
  }
};
